import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from "flarum/forum/app";
import Modal from "flarum/common/components/Modal";
import Button from "flarum/common/components/Button";
import Avatar from "flarum/common/components/Avatar";
import Switch from "flarum/common/components/Switch";
import username from "flarum/common/helpers/username";
import classList from "flarum/common/utils/classList";
import userLink from "../utils/userLink";
import { NotificationLevel } from "../../common/models/Channel";
import chatState from "../state/chat";
import { isOnline } from "../utils/presence";
import { MembersSkeleton } from "./Skeletons";
import { channelIcon } from "../utils/channelIcon";
/**
 * Channel details: notification preferences, the member list, and the moderation
 * actions that change a channel's state.
 *
 * Distinct from ChannelFormModal, which edits what a channel *is* (name, category,
 * threading) and needs the edit permission. This is what any member may see and
 * adjust for themselves, with the state-changing actions gated per capability
 * flag — so a plain member gets a useful panel rather than a locked one.
 */
export default class ChannelInfoModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "tab", "settings");
    _defineProperty(this, "members", []);
    _defineProperty(this, "loadingMembers", false);
    _defineProperty(this, "loadedMembers", false);
    _defineProperty(this, "memberFilter", "");
    _defineProperty(this, "working", false);
    // Candidate search for the add-member field.
    _defineProperty(this, "candidateQuery", "");
    _defineProperty(this, "candidates", []);
    _defineProperty(this, "candidateTimer", null);
    _defineProperty(this, "candidateSequence", 0);
    /** Whether the add-member field is open. */
    _defineProperty(this, "adding", false);
  }
  onremove() {
    if (this.candidateTimer !== null) window.clearTimeout(this.candidateTimer);
  }
  className() {
    return "ChatModal ChatChannelInfoModal Modal--medium";
  }
  title() {
    const channel = this.attrs.channel;
    return m('[', null, m("span", {
      className: "ChatChannelInfo-icon"
    }, channelIcon(channel)), channel.displayName());
  }
  content() {
    return m("div", {
      className: "ChatChannelInfo"
    }, m("div", {
      className: "ChatChannelInfo-tabs"
    }, this.tabButton("settings", "ramon-chat.forum.info.tab_settings"), this.tabButton("members", "ramon-chat.forum.info.tab_members")), this.tab === "settings" ? this.settings() : this.memberTab());
  }
  tabButton(tab, key) {
    return m("button", {
      type: "button",
      className: classList("ChatChannelInfo-tab", {
        "ChatChannelInfo-tab--active": this.tab === tab
      }),
      onclick: () => {
        this.tab = tab;
        if (tab === "members") this.loadMembers();
      }
    }, app.translator.trans(key));
  }

  // ── Settings tab ───────────────────────────────────────────────────────────

  settings() {
    var _channel$notification;
    const channel = this.attrs.channel;
    return m("div", null, channel.description() ? m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-section-label"
    }, app.translator.trans("ramon-chat.forum.info.description")), m("div", null, channel.description())) : null, m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-section-label"
    }, app.translator.trans("ramon-chat.forum.info.notifications")), m("label", null, app.translator.trans("ramon-chat.forum.info.notification_level"), m("select", {
      className: "FormControl",
      value: String((_channel$notification = channel.notificationLevel()) != null ? _channel$notification : NotificationLevel.Mentions),
      onchange: e => this.saveNotifications(Number(e.target.value), null)
    }, m("option", {
      value: String(NotificationLevel.Always)
    }, app.translator.trans("ramon-chat.forum.info.level_always", {}, true)), m("option", {
      value: String(NotificationLevel.Mentions)
    }, app.translator.trans("ramon-chat.forum.info.level_mentions", {}, true)), m("option", {
      value: String(NotificationLevel.Never)
    }, app.translator.trans("ramon-chat.forum.info.level_never", {}, true)))), m(Switch, {
      state: Boolean(channel.isMuted()),
      onchange: value => this.saveNotifications(null, value),
      disabled: this.working
    }, app.translator.trans("ramon-chat.forum.info.mute")), m("div", {
      className: "helpText"
    }, app.translator.trans("ramon-chat.forum.info.mute_help"))), this.moderation());
  }

  /**
   * Actions that change the channel for everyone. Each is drawn only when the
   * server said the actor may do it, so nothing here is present-and-rejected.
   */
  moderation() {
    const channel = this.attrs.channel;
    const items = [];
    if (channel.canClose()) {
      const closed = channel.status() === "closed";
      items.push(m(Button, {
        className: "Button",
        icon: closed ? "fas fa-lock-open" : "fas fa-lock",
        loading: this.working,
        onclick: () => this.setStatus(closed ? "open" : "closed")
      }, app.translator.trans(closed ? "ramon-chat.forum.info.reopen_channel" : "ramon-chat.forum.info.close_channel")));
    }
    if (channel.canArchive() && !channel.archivedAt()) {
      items.push(m(Button, {
        className: "Button",
        icon: "fas fa-box-archive",
        loading: this.working,
        onclick: () => this.archive()
      }, app.translator.trans("ramon-chat.forum.info.archive_channel")));
    }
    if (items.length === 0 && !channel.canDelete()) return null;
    return m('[', null, items.length > 0 ? m("div", {
      className: "ChatChannelInfo-section"
    }, items) : null, channel.canDelete() ? m("div", {
      className: "ChatChannelInfo-danger"
    }, m(Button, {
      className: "Button Button--text",
      icon: "fas fa-trash",
      onclick: () => this.destroy()
    }, app.translator.trans("ramon-chat.forum.info.delete_channel"))) : null);
  }

  // ── Members tab ────────────────────────────────────────────────────────────

  memberTab() {
    if (this.loadingMembers) {
      return m("div", {
        className: "ChatChannelInfo-section"
      }, MembersSkeleton());
    }
    const term = this.memberFilter.trim().toLowerCase();
    const shown = term ? this.members.filter(user => (user.displayName() + " " + user.username()).toLowerCase().includes(term)) : this.members;
    return m("div", {
      className: "ChatChannelInfo-section"
    }, m("div", {
      className: "ChatChannelInfo-memberHeader"
    }, m("span", {
      className: "ChatChannelInfo-memberCount"
    }, app.translator.trans("ramon-chat.forum.channel.members", {
      count: this.members.length
    })), this.attrs.channel.canManageMembers() ? m(Button, {
      className: classList("Button Button--icon Button--flat ChatChannelInfo-addToggle", {
        "ChatChannelInfo-addToggle--open": this.adding
      }),
      icon: this.adding ? "fas fa-xmark" : "fas fa-plus",
      title: app.translator.trans("ramon-chat.forum.info.add_member", {}, true),
      onclick: () => this.toggleAdding()
    }) : null), this.addMembers(), m("input", {
      className: "FormControl ChatChannelInfo-filter",
      type: "search",
      placeholder: app.translator.trans("ramon-chat.forum.info.member_search", {}, true),
      value: this.memberFilter,
      oninput: e => {
        this.memberFilter = e.target.value;
      }
    }), m("div", {
      className: "ChatChannelInfo-memberList"
    }, shown.map(user => {
      var _app$session$user;
      return m("div", {
        key: user.id(),
        className: classList("ChatChannelInfo-member", {
          "ChatChannelInfo-member--online": isOnline(user)
        })
      }, m(Avatar, {
        user: user,
        className: "Avatar"
      }), m("span", null, userLink(user)), this.attrs.channel.canManageMembers() && user.id() !== ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) ? m(Button, {
        className: "Button Button--icon Button--flat ChatChannelInfo-member-remove",
        icon: "fas fa-user-minus",
        disabled: this.working,
        title: app.translator.trans("ramon-chat.forum.info.remove_member", {
          username: username(user)
        }, true),
        onclick: () => this.remove(user)
      }) : null);
    }), shown.length === 0 ? m("div", {
      className: "ChatBrowse-empty"
    }, app.translator.trans("ramon-chat.forum.info.no_members")) : null));
  }

  /**
   * Adding people to the channel.
   *
   * This is how anyone gets into a private channel: it is not discoverable and
   * cannot be joined, so an existing member with `manageMembers` has to put you
   * there. Drawn only when the server says the actor may — a moderator, or the
   * creator of a group conversation.
   */
  addMembers() {
    if (!this.attrs.channel.canManageMembers() || !this.adding) return null;
    const searching = this.candidateQuery.trim().length >= 2;
    return m("div", {
      className: "ChatChannelInfo-add"
    }, m("input", {
      className: "FormControl ChatChannelInfo-add-field",
      type: "search",
      placeholder: app.translator.trans("ramon-chat.forum.info.add_member", {}, true),
      value: this.candidateQuery,
      oninput: e => this.searchCandidates(e.target.value),
      oncreate: vnode => vnode.dom.focus()
    }), this.candidates.length > 0 ? m("div", {
      className: "ChatChannelInfo-candidates"
    }, this.candidates.map(user => m("button", {
      type: "button",
      key: user.id(),
      className: "ChatChannelInfo-candidate",
      disabled: this.working,
      onclick: () => this.add(user)
    }, m(Avatar, {
      user: user,
      className: "Avatar"
    }), m("span", {
      className: "ChatChannelInfo-candidate-name"
    }, username(user)), m("i", {
      className: "ChatChannelInfo-candidate-add fas fa-plus",
      "aria-hidden": "true"
    })))) : searching ? m("div", {
      className: "ChatChannelInfo-add-empty"
    }, app.translator.trans("ramon-chat.forum.info.no_candidates")) : m("div", {
      className: "ChatChannelInfo-add-hint"
    }, app.translator.trans("ramon-chat.forum.info.add_member_hint")));
  }
  toggleAdding() {
    this.adding = !this.adding;

    // Leaving a stale query and its results behind would mean reopening the field
    // shows matches for something typed minutes ago.
    if (!this.adding) {
      this.candidateQuery = "";
      this.candidates = [];
    }
    m.redraw();
  }
  searchCandidates(value) {
    this.candidateQuery = value;
    if (this.candidateTimer !== null) window.clearTimeout(this.candidateTimer);
    if (value.trim().length < 2) {
      this.candidates = [];
      return;
    }
    const mine = ++this.candidateSequence;
    this.candidateTimer = window.setTimeout(() => {
      app.store.find("users", {
        filter: {
          q: value.trim()
        },
        page: {
          limit: 6
        }
      }).then(results => {
        // A slower earlier search must not overwrite a later one.
        if (mine !== this.candidateSequence) return;
        const already = new Set(this.members.map(member => member.id()));

        // Someone already in the channel is not a candidate; offering them and
        // then silently doing nothing is worse than not offering.
        this.candidates = (Array.isArray(results) ? results : []).filter(user => !already.has(user.id()));
        m.redraw();
      }).catch(() => {
        if (mine === this.candidateSequence) this.candidates = [];
      });
    }, 250);
  }
  async add(user) {
    this.working = true;
    m.redraw();
    try {
      var _this$attrs$channel$u;
      const payload = await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(this.attrs.channel.id(), "/members"),
        body: {
          data: {
            attributes: {
              userIds: [Number(user.id())]
            }
          }
        }
      });
      if (payload != null && payload.data) app.store.pushPayload(payload);
      this.members = [...this.members, user];
      this.candidates = this.candidates.filter(candidate => candidate.id() !== user.id());
      this.candidateQuery = "";
      this.attrs.channel.pushAttributes({
        userCount: ((_this$attrs$channel$u = this.attrs.channel.userCount()) != null ? _this$attrs$channel$u : 0) + 1
      });
      app.alerts.show({
        type: "success"
      }, app.translator.trans("ramon-chat.forum.info.member_added", {
        username: username(user)
      }));
    } catch (e) {
      var _e$response$errors$0$, _e$response;
      app.alerts.show({
        type: "error"
      }, (_e$response$errors$0$ = e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) != null ? _e$response$errors$0$ : app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }

  /**
   * Removes someone else from the channel.
   *
   * Confirmed first: unlike adding, this one is not obviously undoable from the
   * other side — a private channel cannot be rejoined, so the person would have to
   * be added back by hand.
   */
  async remove(user) {
    const confirmed = confirm(app.translator.trans("ramon-chat.forum.info.remove_member_confirm", {
      username: username(user)
    }, true));
    if (!confirmed) return;
    this.working = true;
    m.redraw();
    try {
      var _this$attrs$channel$u2;
      const payload = await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(this.attrs.channel.id(), "/members/remove"),
        body: {
          data: {
            attributes: {
              userId: Number(user.id())
            }
          }
        }
      });
      if (payload != null && payload.data) app.store.pushPayload(payload);
      this.members = this.members.filter(member => member.id() !== user.id());

      // Kept in step with the server's own decrement so the count does not sit
      // one high until the next fetch.
      this.attrs.channel.pushAttributes({
        userCount: Math.max(0, ((_this$attrs$channel$u2 = this.attrs.channel.userCount()) != null ? _this$attrs$channel$u2 : 1) - 1)
      });
      app.alerts.show({
        type: "success"
      }, app.translator.trans("ramon-chat.forum.info.member_removed", {
        username: username(user)
      }));
    } catch (e) {
      var _e$response$errors$0$2, _e$response2;
      app.alerts.show({
        type: "error"
      }, (_e$response$errors$0$2 = e == null || (_e$response2 = e.response) == null || (_e$response2 = _e$response2.errors) == null || (_e$response2 = _e$response2[0]) == null ? void 0 : _e$response2.detail) != null ? _e$response$errors$0$2 : app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async loadMembers() {
    if (this.loadedMembers || this.loadingMembers) return;
    this.loadingMembers = true;
    try {
      // Re-fetched with the relationship included rather than read off the
      // sidebar's copy, which is loaded without participants.
      const channel = await app.store.find("chat-channels", String(this.attrs.channel.id()), {
        include: "participants"
      });
      this.members = (channel.participants() || []).filter(Boolean);
    } catch (_unused) {
      this.members = [];
    } finally {
      this.loadingMembers = false;
      this.loadedMembers = true;
      m.redraw();
    }
  }

  // ── Actions ────────────────────────────────────────────────────────────────

  async saveNotifications(level, muted) {
    const channel = this.attrs.channel;

    // Optimistic: the endpoint answers 204, so there is nothing to push back and
    // waiting would leave the control visibly lagging the click.
    channel.pushAttributes(_objectSpread(_objectSpread({}, level !== null ? {
      notificationLevel: level
    } : {}), muted !== null ? {
      isMuted: muted
    } : {}));
    this.working = true;
    m.redraw();
    try {
      await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(channel.id(), "/notifications"),
        body: {
          data: {
            attributes: _objectSpread(_objectSpread({}, level !== null ? {
              notificationLevel: level
            } : {}), muted !== null ? {
              muted
            } : {})
          }
        }
      });
    } catch (_unused2) {
      app.alerts.show({
        type: "error"
      }, app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async setStatus(status) {
    await this.act("/chat-channels/".concat(this.attrs.channel.id(), "/status"), {
      status
    });
  }
  async archive() {
    await this.act("/chat-channels/".concat(this.attrs.channel.id(), "/archive"), {});
  }
  async destroy() {
    if (!confirm(app.translator.trans("ramon-chat.forum.info.delete_confirm", {}, true))) return;
    this.working = true;
    try {
      await this.attrs.channel.delete();
      chatState.channels = chatState.channels.filter(c => c.id() !== this.attrs.channel.id());
      if (chatState.activeChannelId === Number(this.attrs.channel.id())) {
        chatState.setActiveChannel(null);
      }
      this.hide();
    } catch (_unused3) {
      app.alerts.show({
        type: "error"
      }, app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
  async act(path, attributes) {
    this.working = true;
    m.redraw();
    try {
      const payload = await app.request({
        method: "POST",
        url: "".concat(app.forum.attribute("apiUrl")).concat(path),
        body: {
          data: {
            attributes
          }
        }
      });
      if (payload != null && payload.data) app.store.pushPayload(payload);
      this.hide();
    } catch (e) {
      var _e$response$errors$0$3, _e$response3;
      app.alerts.show({
        type: "error"
      }, (_e$response$errors$0$3 = e == null || (_e$response3 = e.response) == null || (_e$response3 = _e$response3.errors) == null || (_e$response3 = _e$response3[0]) == null ? void 0 : _e$response3.detail) != null ? _e$response$errors$0$3 : app.translator.trans("ramon-chat.forum.info.save_failed"));
    } finally {
      this.working = false;
      m.redraw();
    }
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChannelInfoModal', ChannelInfoModal);